import React from 'react';
import Header from "../components/Header/Header";
import Hero from "../components/Hero/Hero";
import Categories from "../components/Categories/Categories";
import Divider from "../components/Divider/Divider";
import YachtFleet from "../components/YachtFleet/YachtFleet";
import Benefits from "../components/Benefits/Benefits";
import FeaturedCruises from '../components/FeaturedCruises/FeaturedCruises';
import Yacht1 from "../assets/images/pngtree-yacht-silhouette-side-view-png-image_11502296.png";
import Yacht2 from "../assets/images/pngtree-yacht-silhouette-side-view-png-image_11502294.png";
import { GrShare } from "react-icons/gr";
import GetInTouch from '../components/GetInTouch/GetInTouch';
import Footer from "../components/Footer/Footer";

const Home = () => (
  <div className="App JosefinSans bg-gray-50">
    <Header />
    <Hero />
    <Categories />
    <Divider
      text="Explore Our Exclusive Yacht Fleet!"
      buttonText="View Yachts"
      buttonLink="/yachts" 
      showImages={true}
      icon={GrShare}
      images={[
        { src: Yacht1, alt: "Yacht 1", className: "" },
        { src: Yacht2, alt: "Yacht 2", className: "-mb-4" }
      ]}
    />
    <YachtFleet />
    <Benefits /> {/* This section is now 'Services' */}
    <FeaturedCruises /> {/* Use the renamed component */}
    <Divider
      text="Ready for an Unforgettable Yachting Experience?"
      buttonText="CONTACT US"
      buttonLink="#contact" // Link to the contact section
    />
    <GetInTouch />
    <Footer />
  </div>
);

export default Home;